import 'leaflet-rotatedmarker';
import { type ReactElement } from 'react';
import { allVMSsFilter, variableMessageSign } from '../LayerFactories';
import { LeafletMap } from '../Map';
import { VariableMessageSignSource } from '../Sources/VariableMessageSign';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

interface VMSPageMapProps extends PageMapProps {
    signId: string;
}

export const VMSPageMap = (props: VMSPageMapProps): ReactElement => {
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        const vmsLayer = variableMessageSign(mapProps.region, {
            source: new VariableMessageSignSource(props.signId, {
                id: 'single-vms-sign-source',
            }),
            disablePopup: true,
            name: 'SingleVMS',
        }).addTo(map);
        allVMSsFilter([vmsLayer]).addTo(map);
    };

    return <LeafletMap {...mapProps} disableFullscreenControl={true} startOnFeatureBounds={true} onMapInitiated={setupMap} />;
};
